import React, { useState, useEffect } from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { Link, useSearchParams } from 'react-router-dom'
import { IoIosArrowForward, IoIosArrowBack } from 'react-icons/io'
// import { Range } from 'react-range'
import { AiFillStar } from 'react-icons/ai'
import { CiStar } from 'react-icons/ci'
import { BsFillGridFill } from 'react-icons/bs'
import { FaThList } from 'react-icons/fa'
// import ShopProducts from '../components/products/ShopProducts'
import Pagination from '../components/Pagination'
import { useDispatch, useSelector } from 'react-redux'
import {
  price_range_product,
  query_products,
  get_sub_categories,
  get_categories,
} from '../store/reducers/homeReducer'

import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie'
import PriceRangeSlider from '../components/PriceRangeSlider'
import ProductSearch from '../components/products/ProductSearch'

const CategoryShop = () => {
  let [searchParams, setSearchParams] = useSearchParams()
  const category = searchParams.get('category')
  // const categoryIdParams = searchParams.get('categoryId')
  // const searchValue = searchParams.get('value')
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch()

  const currentLanguage = i18n.language
  const isRTL = currentLanguage === 'ar' || currentLanguage === 'kr'
  const [currentLanguageCode, setCurrentLanguageCode] = useState(
    cookies.get('i18next') || 'en'
  )
  const [loading, setLoading] = useState(true)

  const {
    products,
    priceRange,
    totalProduct,
    parPage,
    categoriesView,

  } = useSelector((state) => state.home)

  useEffect(() => {
    setCurrentLanguageCode(cookies.get('i18next') || 'kr')
  }, [currentLanguageCode, t, dispatch])

  const [priceValues, setPriceValues] = useState([0, 10000])

  useEffect(() => {
    if (priceRange?.low != null && priceRange?.high != null) {
      const low = Number(priceRange.low)
      const high = Number(priceRange.high)

      if (!isNaN(low) && !isNaN(high)) {
        setPriceValues([low, high])
      }
    }
  }, [priceRange?.low, priceRange?.high])

  const [filter, setFilter] = useState(true)
  const [rating, setRating] = useState('')
  const [styles, setStyles] = useState('grid')
  const [pageNumber, setPageNumber] = useState(1)
  const [sortPrice, setSortPrice] = useState('')
  const [categoryId, setCategoryId] = useState('')
  const [categoryInfo, setCategoryInfo] = useState(null)
  const [categoryName, setCategoryName] = useState('')
  const [searchValue, setSearchValue] = useState('')

  // useEffect(() => {
  //   setCategoryId(searchParams.get('categoryId'))
  // }, [searchParams])

  useEffect(() => {
    const categoryIdFromParams = searchParams.get('categoryId')
    const searchValueFromParams = searchParams.get('value')

    setCategoryId(categoryIdFromParams || '')
    setSearchValue(searchValueFromParams || '')
  }, [searchParams])

  const handleCategoryClick = (id, name) => {
    searchParams.set('categoryId', id)
    searchParams.set('category', name)
    setSearchParams(searchParams)
    setCategoryId(id)
    setCategoryName(name)
    setPageNumber(1) // Reset to first page
  }

  useEffect(() => {
    dispatch(price_range_product())
    dispatch(get_sub_categories())
    dispatch(get_categories())
  }, [searchParams])


 useEffect(() => {
    if (!priceRange?.low || !priceRange?.high) return
  const fetchData = async () => {
      setLoading(true)
     dispatch(
      query_products({
        low: priceValues[0],
        high: priceValues[1],
        categoryId: categoryId || undefined,
        rating: rating || undefined,
        sortPrice: sortPrice || undefined,
        pageNumber,
        searchValue: searchValue || undefined,
      })
    )

      setTimeout(() => {
        setLoading(false)
      }, 1000)
    }

    fetchData()
  }, [
    priceValues,
    categoryId,
    rating,
    sortPrice,
    pageNumber,
    searchValue,
    priceRange,
    category,
    
    dispatch,
    
  ])

  const resetRating = () => {
    setRating('')
    dispatch(
      query_products({
        low: priceValues[0],
        high: priceValues[1],
        categoryId: categoryId || undefined,
        rating: rating || undefined,
        sortPrice: sortPrice || undefined,
        pageNumber,
        searchValue: searchValue || undefined,
      })
    )
  }

  useEffect(() => {
    if (!categoriesView || categoriesView.length === 0 || !categoryId) return

    const getCategoryInfo = (categoryId) => {
      const matchedCategory = categoriesView?.find((c) => c._id === categoryId)

      if (matchedCategory) {
        const nameInLanguage = (() => {
          switch (currentLanguage) {
            case 'ar':
              return matchedCategory.arName
            case 'kr':
              return matchedCategory.kuName
            default:
              return matchedCategory.enName
          }
        })()

        return { categoryId: matchedCategory._id, name: nameInLanguage }
      }

      return null
    }

    const info = getCategoryInfo(categoryId)
    setCategoryInfo(info)
  }, [categoriesView, category, categoryId, currentLanguage])

  const hasActiveFilters = categoryId || 
  priceValues[0] !== priceRange?.low || 
  priceValues[1] !== priceRange?.high || 
  rating || 
  sortPrice || 
  searchValue;

  const getCategoryName = (category) => {
    switch (currentLanguage) {
      case 'ar':
        return category?.arName
      case 'kr':
        return category?.kuName
      default:
        return category?.enName
    }
  }

  return (
    <div>
      <Header />
      <section className=" mt-5 bg-cover bg-no-repeat relative bg-left">
        <div className="absolute left-0 top-0 w-full h-full bg-[#2422228a]">
          <div className="w-[65%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex flex-col justify-center gap-1 items-center h-full w-full text-white"></div>
          </div>
        </div>
      </section>
      <section>
        <div className=" bg-slate-100 py-5 mb-2">
          <div className="w-[68%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto">
            <div className="flex justify-start items-center text-md text-slate-600 w-full">
              <Link to="/"> {t('home.home')}</Link>
              <span>
                <span>
                  {isRTL ? <IoIosArrowBack /> : <IoIosArrowForward />}
                </span>
              </span>
              <Link
                to={`/products?category=${category}&categoryId=${categoryId}`}
              >
                {categoryInfo?.name}
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section>
        {/* Add the reset filters section here */}
{(categoryId || priceValues[0] !== priceRange?.low || priceValues[1] !== priceRange?.high || rating || sortPrice || searchValue) && (
  <div className="bg-green-100 p-1 rounded-md  flex flex-row md:flex-row justify-center items-center md:items-center">
    <div className="px-2 md:mb-0">
      <div className="flex items-center flex-wrap gap-2">
      <h3 className="font-semibold text-slate-700">{t('home.filter_product')}:</h3>
        {categoryId && categoryInfo && (
          <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded">
            {t('products.brand')}: {categoryInfo.name}
          </span>
        )}
        
        {(priceValues[0] !== priceRange?.low || priceValues[1] !== priceRange?.high) && (
          <span className="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded">
            {t('products.price')}: {priceValues[0]} - {priceValues[1]}
          </span>
        )}
        
        {rating && (
          <span className="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded">
            {t('home.rating')}: {rating}+ 
          </span>
        )}
        
        {sortPrice && (
          <span className="bg-purple-100 text-purple-800 text-xs font-medium px-2.5 py-0.5 rounded">
            {t('products.sort_by')}: {sortPrice === 'low-to-high' ? t('products.low_to_high') : t('products.high_to_low')}
          </span>
        )}
        
        {searchValue && (
          <span className="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded">
            {t('home.search')}: "{searchValue}"
          </span>
        )}
      </div>
    </div>
    
    <button 
      onClick={() => {
        // Reset all filters
        setRating('');
        setSortPrice('');
        setPageNumber(1);
        setSearchValue('');
        // Reset price values to the full range
        if (priceRange?.low != null && priceRange?.high != null) {
          setPriceValues([priceRange.low, priceRange.high]);
        }
        // Clear category filter if needed
        if (categoryId) {
          setCategoryId('');
          searchParams.delete('category');
          searchParams.delete('categoryId');
          setSearchParams(searchParams);
        }
      }}
      className="px-4 py-0 bg-red-500 text-white rounded hover:bg-red-600 transition-colors whitespace-nowrap"
    >
      clear
    </button>
  </div>
)}
      </section>

      <section className={`pb-8 ${hasActiveFilters ? 'mt-2' : 'mt-12'}`}>
        <div className="w-[69%] sm:w-full md:w-full sm:p-3 md:p-3 mx-auto  gap-1">
          {loading ? (
            <div className="flex justify-center items-center min-h-[900px]">
              <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : (
            <>
          <div className={` md:block hidden ${!filter ? 'mb-6' : 'mb-0'} `}>
            <button
              onClick={() => setFilter(!filter)}
              className="text-center text-sm font-bold w-full py-2 px-3 bg-primary text-white"
            >
              {t('home.filter_product')}
            </button>
          </div>
          <div className="w-full flex flex-wrap  sm:md:gap-5">
            <div className={`w-3/12 md-lg:w-4/12 md:w-full   `}>
              <div
                className={`border  rounded-md px-8 ${
                  isRTL ? 'px-10' : 'px-8'
                } ${
                  filter
                    ? 'md:h-0 md:overflow-hidden md:mb-8'
                    : 'md:h-auto  md:overflow-auto md:mb-0'
                }`}
              >
                <div className="py-3 flex flex-col gap-3  border-b-2 mb-4">
                  <h2 className="text-sm font-bold mb-2 text-slate-600">
                    {t('products.brands')}
                  </h2>
                  <div className="space-y-2 pl-4 cursor-pointer">
                    {categoriesView?.length > 0
                      ? categoriesView.map((category) => (
                          <div
                            key={category._id}
                            onClick={() =>
                              handleCategoryClick(category._id, category.enName)
                            }
                            className="text-gray-600"
                          >
                            - {getCategoryName(category)}{' '}
                          </div>
                        ))
                      : null}
                  </div>
                </div>
                <div className="py-2 flex flex-col gap-4 border-b-2 mb-4">
                  <h2 className="text-md font-bold mb-2 text-slate-600">
                    {t('products.price')}
                  </h2>
                  {!priceValues.some(isNaN) && (
                    <PriceRangeSlider
                      priceRange={priceRange}
                      isRTL={isRTL}
                      onChange={(values) => setPriceValues(values)}
                    />
                  )}
                  {/* <Range
                    step={0.01}
                    min={adjustedPriceRange.low}
                    max={adjustedPriceRange.high}
                    values={state.values}
                    onChange={(values) => setState({ values })}
                    renderTrack={({ props, children }) => (
                      <div
                        {...props}
                        className="w-full h-[6px] bg-slate-200 rounded-full cursor-pointer"
                      >
                        {children}
                      </div>
                    )}
                    renderThumb={({ props }) => (
                      <div
                        {...props}
                        className="w-[15px] h-[15px] bg-primary rounded-full"
                      />
                    )}
                    rtl={isRTL}
                  /> */}
                  {/* <div className="flex flex-col md:flex-row min-w-0">
                    <span className="text-slate-800 font-bold text-lg md:text-xl">
                      {isRTL ? (
                        <>
                          {Math.floor(state.values[1] * currencyIQD)} -{' '}
                          {Math.floor(state.values[0] * currencyIQD)}
                        </>
                      ) : (
                        <>
                          {Math.floor(state.values[0] * currencyIQD)} -{' '}
                          {Math.floor(state.values[1] * currencyIQD)}
                        </>
                      )}
                    </span>
                  </div> */}
                </div>
                <div className="py-3 flex flex-col gap-3 border-b-2 mb-4">
                  <h2 className="text-md font-bold mb-2 text-slate-600">
                    {t('home.rating')}{' '}
                  </h2>
                  <div className="flex flex-col gap-3">
                    <div
                      onClick={() => setRating(5)}
                      className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                    >
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <AiFillStar />{' '}
                      </span>
                    </div>

                    <div
                      onClick={() => setRating(4)}
                      className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                    >
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                    </div>

                    <div
                      onClick={() => setRating(3)}
                      className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                    >
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                    </div>

                    <div
                      onClick={() => setRating(2)}
                      className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                    >
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                    </div>

                    <div
                      onClick={() => setRating(1)}
                      className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                    >
                      <span>
                        <AiFillStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                    </div>

                    <div
                      onClick={resetRating}
                      className="text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer"
                    >
                      <span>
                        <CiStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                      <span>
                        <CiStar />{' '}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-9/12 md-lg:w-8/12 md:w-full">
              <div className={`${isRTL ? 'pr-8  md:pr-0' : 'pl-8  md:pl-0'} `}>
                <div className="py-3 bg-white mb-6 px-3 rounded-md flex justify-between  border">
                  <div className="flex justify-center items-center gap-3">
                    <h2 className="text-lg font-medium text-slate-600">
                      {' '}
                      ({totalProduct}) {t('products.products')}{' '}
                    </h2>
                  </div>
                  <div className="flex justify-center items-center gap-3">
                    <select
                      onChange={(e) => setSortPrice(e.target.value)}
                      className="p-1 border outline-0 text-slate-600 text-sm font-semibold"
                      name=""
                      id=""
                    >
                      <option value="">{t('products.sort_by')}</option>
                      <option value="low-to-high">
                        {t('products.low_to_high')}
                      </option>
                      <option value="high-to-low">
                        {t('products.high_to_low')}
                      </option>
                    </select>
                    <div className="flex justify-center items-start gap-4 md-lg:hidden">
                      <div
                        onClick={() => setStyles('grid')}
                        className={`p-2 ${
                          styles === 'grid' && 'bg-slate-300'
                        } text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm `}
                      >
                        <BsFillGridFill />
                      </div>
                      <div
                        onClick={() => setStyles('list')}
                        className={`p-2 ${
                          styles === 'list' && 'bg-slate-300'
                        } text-slate-600 hover:bg-slate-300 cursor-pointer rounded-sm `}
                      >
                        <FaThList />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="relative min-h-screen">
                  {/* {loader ? (
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex justify-center items-center">
                      <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
                    </div>
                  ) : (
                    <>
                      {products.length === 0 ? (
                        <div>No products found</div>
                      ) : (
                        <> */}
                          <div className="pb-8">
                            <ProductSearch products={products} styles={styles} />
                          </div>

                          <div>
                            {totalProduct > parPage && (
                              <Pagination
                                pageNumber={pageNumber}
                                setPageNumber={setPageNumber}
                                totalItem={totalProduct}
                                parPage={parPage}
                                showItem={Math.floor(totalProduct / parPage)}
                              />
                            )}
                          </div>
                        {/* </>
                      )}
                    </>
                  )} */}
                </div>
              </div>
            </div>
          </div>
          </>
          )}
        </div>
      </section>

      <Footer />
    </div>
  )
}

export default CategoryShop
